module.exports = __webpack_public_path__ + "img/school_xnsz.f877db07.png";